import { render, staticRenderFns } from "./multiSelect.vue?vue&type=template&id=1935d0f2&scoped=true"
import script from "./multiSelect.vue?vue&type=script&lang=js"
export * from "./multiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935d0f2",
  null
  
)

export default component.exports